export { default as cosmosTailwindPlugin } from './cosmos-tailwind-plugin.esm.js';
export { default as getCosmosTailwindPreset } from './get-cosmos-tailwind-preset.esm.js';
export { default as getResetScoping } from './get-reset-scoping.esm.js';
export { cn, getTvObject, tv, twMerge } from './utils/index.esm.js';

// equivalent setting with tailwind default
var breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536
};

export { breakpoints };
//# sourceMappingURL=index.esm.js.map
